import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaGoogle } from 'react-icons/fa';
import useResizeObserverFix from '../hooks/useResizeObserverFix';
import './GoogleReviews.css';

const GoogleReviews = () => {
  // Use the hook to fix ResizeObserver errors
  useResizeObserverFix();
  
  useEffect(() => {
    // Add a small delay before loading the widget to prevent resize observer errors
    const timer = setTimeout(() => {
      if (window.elfsight) {
        window.elfsight.reinit();
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="google-reviews">
      <div className="container">
        <motion.div 
          className="reviews-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="google-badge">
            <FaGoogle className="google-icon" />
          </div>
          <h2>What Our Customers Say</h2>
          <p>Read verified reviews from our customers on Google</p>
        </motion.div>
        
        <motion.div 
          className="google-reviews-widget"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <div className="elfsight-app-58ca2e48-ab84-4f00-b5a8-68131e0fbcb2" data-elfsight-app-lazy></div>
        </motion.div>
        
        <motion.div 
          className="reviews-cta"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <a href="https://g.co/kgs/bV8MhYg" target="_blank" rel="noopener noreferrer" className="review-button">
            Leave Us a Review
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default GoogleReviews; 